module.exports = __webpack_public_path__ + "img/Jobs.64939872.jpg";